import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {PAY} from '@web/core/urls'
import {unsubscribeMessage, subscribeMessage, changeBrowserLocation, openPopup} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {NavigationResult, NavigationTypeSelectableParam, PopupMessageReceiveParam, ThunkApi} from '../interfaces'
import {getBackUrl} from '../utils'

const AML_CDD_REGISTER_URL = `${PAY}/member/aml/cdd/register`

const POPUP_KEY = 'AML_CDD_REGISTER'
const MESSAGE_KEY = 'AML_REGISTER'

/**
 * AML CDD (Anti-Money Laundry Customer Due Diligence, 자금세탁방지 고객확인의무) 등록 이행페이지로 이동
 * about CDD: https://wiki.fin.navercorp.com/pages/viewpage.action?pageId=46035457
 */
const navigateToCDDRegisterForAML = createAsyncThunk<
    NavigationResult,
    NavigationTypeSelectableParam & PopupMessageReceiveParam & {amlToken: string},
    ThunkApi
>('navigateTo/CDDRegisterForAML', async (args) => {
    const {amlToken, bridgeUrl, forceLocationChange = false} = args
    const shouldChangeLocation = forceLocationChange || isMobile

    if (shouldChangeLocation) {
        const url = qs.stringifyUrl({
            url: AML_CDD_REGISTER_URL,
            query: {
                sUrl: getBackUrl(),
                rUrl: getBackUrl(),
            },
        })

        changeBrowserLocation({url, type: 'PUSH'})
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    }

    const popupUrl = qs.stringifyUrl({
        url: AML_CDD_REGISTER_URL,
        query: {
            amlToken,
            treatmentService: 'ORDER',
            fromPC: 'Y',
        },
    })

    return new Promise<string | void>((resolve, reject) => {
        const resolveCallback = () => resolve('success')

        // popup으로부터 유효한 메시지 받았을 때만 result로  메시지 전달
        subscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})

        // popup만 오픈
        openPopup({
            key: POPUP_KEY,
            url: popupUrl,
            popupQuery: {
                rurl: `${bridgeUrl}/${MESSAGE_KEY}/success`,
                callback: MESSAGE_KEY,
            },
            size: {
                width: 500,
                height: 640,
            },
        })
            .then(() => resolve())
            .catch(reject)
            .finally(() => {
                // popup open 실패했든 종료했든 popup open시도가 끝났다면 message subscription 종료
                unsubscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})
            })
    })
})

export default navigateToCDDRegisterForAML
